<div class="top">
  <button *ngIf="hasPermission('manage_payplans')" class="floatR marginB" nz-button nzType="primary" nzShape="circle" (click)="showModal(false)">
    <span nz-icon nzType="plus" nzTheme="outline"></span>
  </button>

  <nz-form-item class="floatL" style="width: 50%;" *ngIf="hasPermission('view_all_payplans') || hasPermission('view_distributors_payplans')">
    <nz-form-label>Company</nz-form-label>
    <nz-select nzShowSearch nzAllowClear [(ngModel)]="selectedCompany" (ngModelChange)="getAssociatedCompanyInfo(); spinner = true" style="width: 100%;">
      <nz-option *ngFor="let c of companies" [nzValue]="c.id" [nzLabel]="c.name"></nz-option>
    </nz-select>
  </nz-form-item> 
</div>

<div style="padding: 20px">
  <nz-input-group nzPrefixIcon="search">
    <input nzAllowClear style="padding: 10px" (keyup)="search($event)" type="text" nz-input placeholder="Search by Plan Name" />
  </nz-input-group>
</div>

<div>
  <nz-table #plansTable [nzData]="payplansList" nzShowSizeChanger [nzLoading]="spinner">
    <thead>
      <tr>
        <th>Name</th>
        <th>Start Date</th>
        <th>End Date</th>
        <th>Status</th>
        <th>Rules</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
    <tr *ngFor="let data of plansTable.data">
      <td>{{ data.name | titlecase }}</td>
      <td>{{ data.start_date | date: 'MM/dd/yyyy' }}</td>
      <td>{{ data.end_date | date: 'MM/dd/yyyy' }}</td>
      <td>
        <nz-switch
          [(ngModel)]="data.active"
          (ngModelChange)="togglePayplanActive(data.id, $event)"
          [nzLoading]="data.isToggling">
        </nz-switch>
      </td>
      <td>
        <ul *ngIf="data.rules && data.rules.length > 0">
          <li *ngFor="let rule of data.rules">{{ rule.description }}</li>
        </ul>
        <span *ngIf="!data.rules || data.rules.length === 0">No rules</span>
      </td>
      <td>
        <button nz-button nzType="primary" nzShape="circle" (click)="showModal(data)">
          <span nz-icon nzType="edit"></span>
        </button>
        <button nz-button nzType="primary" nzShape="circle" (click)="showRuleEditor(data)" class="action-button">
          <span nz-icon nzType="calculator"></span>
        </button>         
      </td>
    </tr>
    </tbody>
  </nz-table>
</div>

<nz-modal [(nzVisible)]="addModal" nzTitle="Payplan" nzCentered (nzOnCancel)="cancelModal()" (nzOnOk)="saveModal()">
  <ng-container *nzModalContent>

    <form [formGroup]="planForm">

      <nz-form-item>
        <nz-form-label nzRequired>Plan Name</nz-form-label>
        <input nz-input formControlName="name" placeholder="Payplan 1" />
      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzRequired>Date Range</nz-form-label>
        <nz-range-picker formControlName="dateRange"></nz-range-picker>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzRequired>Company</nz-form-label>
        <nz-select nzShowSearch nzAllowClear formControlName="company" nzPlaceHolder="Select company payplan belongs to" (ngModelChange)="getUsersandProviders()">
          <nz-option *ngFor="let c of companies" [nzValue]="c.id" [nzLabel]="c.name"></nz-option>
        </nz-select>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label>Assignment Type</nz-form-label>
        <nz-radio-group [(ngModel)]="selectionMode" [ngModelOptions]="{standalone: true}" (ngModelChange)="onSelectionModeChange($event)">
          <label nz-radio-button nzValue="users">Individual Users</label>
          <label nz-radio-button nzValue="groups">Groups</label>
        </nz-radio-group>
      </nz-form-item>

      <nz-form-item *ngIf="selectionMode === 'users'">
        <nz-form-label>Users</nz-form-label>
        <nz-select 
          nzMode="multiple" 
          nzAllowClear 
          nzShowSearch 
          nzPlaceHolder="Select individual users" 
          [nzLoading]="loadingUsers" 
          formControlName="users">
          <nz-option 
            *ngFor="let u of users" 
            [nzLabel]="u.first_name + ' ' + u.last_name" 
            [nzValue]="u.id">
          </nz-option>
        </nz-select>
      </nz-form-item>

      <nz-form-item *ngIf="selectionMode === 'groups'">
        <nz-form-label>Groups</nz-form-label>
        <nz-select 
          nzMode="multiple" 
          nzAllowClear 
          nzShowSearch 
          nzPlaceHolder="Select groups (applies to all users in selected groups)" 
          [nzLoading]="loadingUsers" 
          formControlName="groups">
          <nz-option 
            *ngFor="let g of groups" 
            [nzLabel]="g.name" 
            [nzValue]="g.id">
          </nz-option>
        </nz-select>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzRequired>Provider</nz-form-label>
        <nz-select [nzLoading]="loadingUsers" nzShowSearch nzAllowClear formControlName="provider" nzPlaceHolder="Select provider payplan belongs to">
          <nz-option *ngFor="let p of providers" [nzValue]="p.id" [nzLabel]="p.name"></nz-option>
        </nz-select>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzRequired>Product</nz-form-label>
        <nz-select nzShowSearch nzAllowClear formControlName="product">
          <nz-option nzValue="fiber" nzLabel="fiber"></nz-option>
        </nz-select>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label>Holdback</nz-form-label>
        <div style="display:flex; gap:12px; align-items:center;">
          <label>Enabled</label>
          <nz-switch formControlName="holdback_enabled"></nz-switch>

          <nz-input-group nzAddOnAfter="%">
            <input nz-input type="number" min="0" max="100" formControlName="holdback_percentage" [disabled]="!planForm.value.holdback_enabled" />
          </nz-input-group>

          <nz-input-group nzAddOnAfter="days">
            <input nz-input type="number" min="0" formControlName="holdback_days" [disabled]="!planForm.value.holdback_enabled" />
          </nz-input-group>
        </div>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzRequired>Payplan Type</nz-form-label>
        <nz-select formControlName="type" nzPlaceHolder="Select payplan type">
          <nz-option 
            *ngFor="let type of payplanTypes" 
            [nzValue]="type.value" 
            [nzLabel]="type.label">
          </nz-option>
        </nz-select>
      </nz-form-item>

      <!-- Retroactive (create only) -->
 
<nz-form-item *ngIf="!planForm.get('id')?.value">
  <nz-form-label>Retroactive</nz-form-label>
  <nz-switch [(ngModel)]="retroactive" [ngModelOptions]="{ standalone: true }"></nz-switch>
</nz-form-item>

<nz-form-item *ngIf="!planForm.get('id')?.value && retroactive">
  <nz-form-label>From date</nz-form-label>
  <nz-date-picker [(ngModel)]="fromDate" [ngModelOptions]="{ standalone: true }"></nz-date-picker>
</nz-form-item>

    </form>
  

    <nz-list *ngIf="displayStates.length > 0">
      <div style="cursor: pointer;" *ngFor="let ds of displayStates" (click)="editPPW(ds)">
        <nz-list-item style="padding: 0px;" *ngFor="let s of ds.states">
          {{ ds.amount }} - {{s.label}}
        </nz-list-item>
      </div>
    </nz-list>

    <button *ngIf="!planForm.get('id')?.value" style="margin-bottom: 5px;" nz-button nzSize="small" nzType="primary" (click)="showLogicBuilder()">Add Dynamic Logic</button>

    <app-dynamic-logic-builder 
    *ngIf="showLogicBuilderModal" 
    [projectColumns]="projectColumns" 
    [users]="users"
    [groups]="groups"
    (logicBuilt)="onLogicBuilt($event)">
  </app-dynamic-logic-builder>

    <nz-list *ngIf="dynamicLogicRules.length > 0">
      <nz-list-item *ngFor="let rule of dynamicLogicRules; let i = index">
        <span>{{ rule.description }}</span>
        <button nz-button nzSize="small" nzType="default" (click)="editLogicRule(i)">Edit</button>
        <button nz-button nzSize="small" nzType="primary" nzDanger (click)="deleteLogicRule(i)">Delete</button>
      </nz-list-item>
    </nz-list>
  </ng-container>
</nz-modal>

<!-- <app-payplans-addstates-modal *ngIf="valuesModal" [states]="states" [amount]="amount" (close)="closedModal($event)" (info)="catchInfo($event)"></app-payplans-addstates-modal> -->

<nz-drawer
  [nzVisible]="calculatedResults.length > 0"
  nzTitle="Payroll Results"
  (nzOnClose)="calculatedResults = []"
  [nzWidth]="720">
  <ng-container *nzDrawerContent>
    <nz-collapse>
      <nz-collapse-panel 
        *ngFor="let userResult of calculatedResults"
        [nzHeader]="userPanelHeader"
        [nzActive]="true">
        <ng-template #userPanelHeader>
          <div class="panel-header">
            <span>{{ userResult.userName }}</span>
            <span class="panel-total">{{ userResult.totalCommission | currency }}</span>
          </div>
        </ng-template>

        <nz-table [nzData]="userResult.customers">
          <thead>
            <tr>
              <th>Customer Name</th>
              <th>Commission</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let customer of userResult.customers">
              <td>{{ customer.customerName }}</td>
              <td>{{ customer.commission | currency }}</td>
            </tr>
          </tbody>
        </nz-table>
      </nz-collapse-panel>
    </nz-collapse>

    <div class="total-section">
      <h2>Grand Total: {{ getGrandTotal() | currency }}</h2>
    </div>
  </ng-container>
</nz-drawer>

<nz-modal
  [(nzVisible)]="editingRules"
  [nzTitle]="'Edit Payplan Rules'"
  (nzOnCancel)="editingRules = false"
  (nzOnOk)="savePayplanRules()">

  <ng-container *nzModalContent>
    <button 
      style="margin-bottom: 5px;" 
      nz-button 
      nzSize="small" 
      nzType="primary" 
      (click)="showLogicBuilder()">
      Add Rule
    </button>

    <nz-list *ngIf="editingPayplanRules.length > 0">
      <nz-list-item *ngFor="let rule of editingPayplanRules; let i = index">
        <span>{{ rule.description }}</span>
        <button nz-button nzSize="small" nzType="primary" nzDanger (click)="deleteLogicRule(i)">
          Delete
        </button>
      </nz-list-item>
    </nz-list>

    <app-dynamic-logic-builder 
    *ngIf="showLogicBuilderModal" 
    [projectColumns]="projectColumns" 
    [users]="users"
    [groups]="groups"
    (logicBuilt)="onLogicBuilt($event)">
  </app-dynamic-logic-builder>

    <!-- New: Retroactive controls -->
    <nz-form-item>
      <nz-form-label>Retroactive</nz-form-label>
      <nz-switch [(ngModel)]="retroactive" [ngModelOptions]="{ standalone: true }"></nz-switch>
    </nz-form-item>

    <nz-form-item *ngIf="retroactive">
      <nz-form-label>From date</nz-form-label>
      <nz-date-picker [(ngModel)]="fromDate" [ngModelOptions]="{ standalone: true }"></nz-date-picker>
    </nz-form-item>
  </ng-container>
</nz-modal>

<!-- Add the conflict modal -->
<nz-modal
  [(nzVisible)]="showConflictModal"
  nzTitle="Payplan Date Conflict Detected"
  [nzFooter]="null"
  (nzOnCancel)="showConflictModal = false">
  <ng-container *nzModalContent>
    <div class="conflict-warning">
      <span nz-icon nzType="warning" nzTheme="fill" style="color: #faad14; margin-right: 8px;"></span>
      <span>The following users already have active base payplans for the selected provider during the specified date range:</span>
    </div>

    <nz-list [nzDataSource]="userPayplanConflicts" [nzRenderItem]="conflictItem">
      <ng-template #conflictItem let-conflict>
        <nz-list-item>
          <div class="conflict-item">
            <div>
              <strong>{{ conflict.userName }}</strong>
              <p>Current payplan: {{ conflict.existingPayplan.name }}</p>
              <p>Date Range: {{ conflict.existingPayplan.start_date | date }} - {{ conflict.existingPayplan.end_date | date }}</p>
            </div>
            <div class="conflict-actions">
              <button nz-button nzType="primary" (click)="editExistingPayplan(conflict.existingPayplan.id)">
                Edit Existing Payplan
              </button>
            </div>
          </div>
        </nz-list-item>
      </ng-template>
    </nz-list>

    <div class="conflict-footer" style="margin-top: 16px; text-align: right;">
      <button nz-button nzType="default" (click)="showConflictModal = false" style="margin-right: 8px;">
        Cancel
      </button>
      <button nz-button nzType="primary" (click)="editCurrentPayplanDates()">
        Edit Current Payplan Dates
      </button>
    </div>
  </ng-container>
</nz-modal>

<!-- New: Preview confirmation modal for rule changes -->
<nz-modal
  [(nzVisible)]="showRulesPreviewModal"
  nzTitle="Preview rule changes"
  (nzOnCancel)="showRulesPreviewModal = false"
  [nzOkText]="'Approve and Save'"
  (nzOnOk)="confirmApproveRules()">

  <ng-container *nzModalContent>
    <p>Old rules: {{ rulesPreview?.oldRulesCount }} | New rules: {{ rulesPreview?.newRulesCount }}</p>

    <ng-container *ngIf="rulesPreview?.retroactive">
      <p>Retroactive from: {{ rulesPreview?.fromDate | date }}</p>
      <p>Adjustment rows to apply: {{ rulesPreview?.items?.length || 0 }}</p>
    </ng-container>

    <ng-container *ngIf="!rulesPreview?.retroactive">
      <p>This change is not retroactive.</p>
    </ng-container>
  </ng-container>
</nz-modal>